import React, { useState } from "react"
import { ReactComponent as EFormCreateBtn } from "@/assets/svgs/eformv2-create-btn.svg";
import { ReactComponent as ArrowDown } from "@/assets/svgs/chevron-down.svg";
import { ReactComponent as DeleteIcon } from "@/assets/svgs/trash.svg";
import PropTypes from 'prop-types';

const EFormAccordion = ({
	testId,
	title,
	subTitle,
	defaultState = true,
	children,
	level = 0,
	fieldType,
	isRequired,
	handleAddFunc,
	handleRemoveFunc,
	parentProps,
	arrIdx = 0,
	isCreated = false,
	field,
	allowDeletion,
	isReadOnly = false
}) => {
	const [isOpen, setIsOpen] = useState(defaultState);

	function handleAccordionClick() {
		setIsOpen(!isOpen);
	}

	function handleDeleteAccordion(parentProps, index, isReadOnly) {
		if (isReadOnly) return;
		handleRemoveFunc(parentProps, index);
	}

	const handleCreateAccordion = (parentProps, fieldSchema) => {
		let updatedFieldSchema = { ...fieldSchema };
		let isObject = false;
		if (Array.isArray(updatedFieldSchema.type) && updatedFieldSchema.type.includes("object")) {
			const nonNullType = updatedFieldSchema.type.find(f => f !== 'null');
			updatedFieldSchema.type = nonNullType;
			isObject = true;
		}
		handleAddFunc(parentProps, updatedFieldSchema, isObject);
		setIsOpen(true)
	}

	function renderHeaderAccordion(isReadOnly) {
		return (
			<div className="eformv2-accordion-thread-container" data-testid={`${testId}__accordion`} >
				{level !== 1 && <span className="thread"></span>}
				<div className={`eformv2-accordion__container eformv2-accordion__container-style--header-${level}`} >
					<div className="eformv2-accordion__info" onClick={handleAccordionClick}>
						<div className="eformv2-accordion__action-icon" style={
							{
								transform: isOpen ? 'rotate(0deg)' : 'rotate(-90deg)',
								transition: 'transform 0.2s ease-in-out'
							}
						}><ArrowDown /></div>
						<div className="eformv2-accordion__titles">
							{isRequired && <span className="eformv2-label-asterisk" data-testid="eform-label-asterisk">*</span>}
							<div>
								<div className="eformv2-accordion__main-title--header">
									{title}
									{fieldType === 'array' && ` #${arrIdx + 1}`}
								</div>
								<div className="eformv2-accordion__sub-title--header">{subTitle}</div>
							</div>
						</div>
					</div>

					{/* Delete Action */}
					{
						!isReadOnly && ((fieldType === 'object' && !isRequired) || (fieldType === 'array' && (allowDeletion || !isRequired))) &&
						(
							<div
								className={`eformv2-accordion__action-delete ${isReadOnly ? 'disabled' : ''}`}
								data-testid={`${testId}__delete-accordion-btn`}
								onClick={() => handleDeleteAccordion(parentProps, arrIdx, isReadOnly)}
								onKeyDown={(e) => e.key === 'Enter' && handleDeleteAccordion(parentProps, arrIdx, isReadOnly)}
								role="button"
								tabIndex={0}
							>
								<div className={`eformv2-accordion__action-icon eformv2-accordion__delete-icon ${isReadOnly ? 'disabled' : ''}`}>
									<DeleteIcon />
								</div>
								<div className={`eformv2-accordion__delete-text ${isReadOnly ? 'disabled' : ''}`}>
									Delete
								</div>
							</div>
						)
					}

				</div>
			</div>
		)
	}

	function renderCreateAccordion(parentProps, fieldSchema, isObj = false,){
		return (
			<div className="eformv2-accordion-thread-container" data-testid={`${testId}__create-accordion`} >
				{level !== 1 && <span className={`thread ${isObj ? "optional-obj" : ""}`}></span>}
				<div className={`eformv2-accordion__container eformv2-accordion__container-style--action-${level}`} onClick={() => handleCreateAccordion(parentProps, fieldSchema)}>
					<div className="eformv2-accordion__action-icon"><EFormCreateBtn /></div>
					<div>
						<div className="eformv2-accordion__main-title--action">
							{`Create ${title}`}
						</div>
						<div className="eformv2-accordion__sub-title--action">{subTitle}</div>
					</div>
				</div>
			</div>
		)

	}

	if (fieldType === 'object' && !isRequired) {
		return (
			<>
				{!isCreated && !isReadOnly && (renderCreateAccordion(parentProps, field, true))}

				{isCreated && (
					<>
						{renderHeaderAccordion(isReadOnly)}
						{isOpen && (
							<div style={{ marginLeft: `${level === 1 ? 30 : 25}px` }}>
								{children}
							</div>
						)}
					</>
				)}
			</>
		)
	}

	if (fieldType === 'object' && isRequired) {
		return (
			<div>
				{renderHeaderAccordion(isReadOnly)}
				{isOpen && (
					<div>
						<div style={{ marginLeft: `${level === 1 ? 30 : 25}px` }}>
							{children}
						</div>
					</div>
				)}
			</div>
		)
	}

	if (fieldType === 'array' && !isRequired) {
		return (
			<>
				{!isCreated && !isReadOnly && (renderCreateAccordion(parentProps, field.items, false))}

				{isCreated && (
					<>
						{renderHeaderAccordion(isReadOnly)}
						{isOpen && (
							<div>
								<div style={{ marginLeft: `${level === 1 ? 30 : 25}px` }}>
									{children}
								</div>

							</div>
						)}
					</>
				)}
			</>
		)
	}

	if (fieldType === 'array' && isRequired) {
		return (
			<div>
				{renderHeaderAccordion(isReadOnly)}
				{isOpen && (
					<div>
						<div style={{ marginLeft: `${level === 1 ? 30 : 25}px` }}>
							{children}
						</div>
					</div>
				)}
			</div>
		)
	}
	return null;
}

EFormAccordion.propTypes = {
	testId: PropTypes.string,
    title: PropTypes.string,
    subTitle: PropTypes.string,
    defaultState: PropTypes.bool,
    children: PropTypes.node,
    level: PropTypes.number,
    fieldType: PropTypes.string,
    isRequired: PropTypes.bool,
    handleAddFunc: PropTypes.func,
    handleRemoveFunc: PropTypes.func,
    parentProps: PropTypes.array,
    arrIdx: PropTypes.number,
    isCreated: PropTypes.bool,
	isReadOnly: PropTypes.bool,
	allowDeletion: PropTypes.bool,
    field: PropTypes.shape({
        items: PropTypes.any,
    }),
};

export default EFormAccordion
